import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

/* Etichetta di stato (pacchetto del 29-10): sempre una parola, il colore aiuta soltanto.
   24 px, angolo 6, testo 12 in grassetto. */
const statusBadgeVariants = cva(
  "inline-flex h-6 shrink-0 items-center gap-1 whitespace-nowrap rounded-xs px-2 text-caption font-bold tabular-nums",
  {
    variants: {
      tone: {
        success: "bg-success-bg text-success-ink", // Firmato, Attivo, Incassato
        warning: "bg-warning-bg text-warning-ink", // Scade tra 5 giorni, Invitata
        danger: "bg-danger-bg text-danger-ink", // Scaduta da 39 giorni
        neutral: "bg-surface-3 text-ink-2", // Bozza, Spento
        brand: "bg-brand-subtle text-brand-ink", // nuova
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export function StatusBadge({ className, tone, ...props }) {
  return <span data-slot="status-badge" className={cn(statusBadgeVariants({ tone }), className)} {...props} />;
}

/**
 * Contatore accanto a una voce del menu blu. Colori fissi (il menu è blu anche nel tema scuro):
 * plain per i conteggi, warning per le cose da sistemare, danger per qualcosa di scaduto.
 */
export function NavCounter({ children, tone = "plain", ...props }) {
  if (tone === "plain")
    return (
      <span className="text-caption tabular-nums text-white/80" {...props}>
        {children}
      </span>
    );
  return (
    <span
      className={cn(
        "inline-flex h-5 items-center rounded-xs px-1.5 text-caption font-bold tabular-nums",
        tone === "danger" ? "bg-nav-button text-nav-alert-ink" : "bg-nav-warn-bg text-nav-warn-ink",
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export { statusBadgeVariants };
